(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-content"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        const tocLinks = document.querySelectorAll(".table-of-content a");

        if (tocLinks.length > 0) {
            tocLinks[0].classList.add("active");
        }

        tocLinks.forEach(link => {
            link.addEventListener("click", function() {
            tocLinks.forEach(l => l.classList.remove("active"));
            this.classList.add("active");
            });
        });
    });

  } catch(e) { console.error(e); }
})();
})();
